import { KeyRound } from 'lucide-react';
import { Button, EmptyState } from '@/components/ds-dlp';
import { useAuth } from '../contexts/AuthContext';
import { BRAND } from '../brand';

/**
 * Shown instead of the console while the on-prem licence is not valid, to a
 * user who cannot activate one (no settings.manage). Administrators are sent
 * to Settings > License instead (App.tsx).
 */
export default function LicenseRequired() {
  const { license, logout, user } = useAuth();
  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-[var(--d2d-bg-primary)] p-6">
      <EmptyState
        icon={<KeyRound />}
        title={`${BRAND.name} is not licensed`}
        description={
          <>
            {license?.message || 'This installation has no valid licence.'} Contact your administrator
            {user?.email ? ` (you are signed in as ${user.email})` : ''}.
          </>
        }
        action={<Button onClick={logout}>Sign out</Button>}
        headingLevel={2}
      />
    </div>
  );
}
